// extracted by mini-css-extract-plugin
export var wideimage = "wideimage-module--wideimage--2pP-6";
export var image = "wideimage-module--image--1hrBu";
export var description = "wideimage-module--description--2NDZx";